<script setup>
import SportLiveTvFilterActions from '@/sport-live-tv/components/sport-live-tv-filter-actions.vue';
import SportLiveTvFilterGroup from '@/sport-live-tv/components/sport-live-tv-filter-group.vue';
import SportLiveTvFilterSteps from '@/sport-live-tv/components/sport-live-tv-filter-steps.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  groups: { type: Array, required: true },
});

const emit = defineEmits(['toggle', 'open', 'clear', 'apply']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <div class="sport-live-tv-filter-overview">
    <div class="sport-live-tv-filter-overview__header">
      <p class="sport-live-tv-filter-overview__title">{{ t('filtering') }}</p>
      <p class="sport-live-tv-filter-overview__hint sport-live-tv-filter-overview__hint--desktop">{{ t('filteringHint') }}</p>
      <p class="sport-live-tv-filter-overview__hint sport-live-tv-filter-overview__hint--mobile">{{ t('filteringHintMobile') }}</p>
    </div>
    <div class="sport-live-tv-filter-overview__groups">
      <SportLiveTvFilterGroup
        v-for="group in groups"
        :key="group.key"
        :title="group.title"
        :search-placeholder="group.searchPlaceholder"
        :options="group.options"
        :selected="group.selected"
        @toggle="emit('toggle', group.key, $event)"
      />
    </div>
    <SportLiveTvFilterSteps :groups="groups" @open="emit('open', $event)" />
    <SportLiveTvFilterActions @clear="emit('clear')" @apply="emit('apply')" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-filter-overview {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__header {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    margin: 0;
    color: $white;
    font-size: 15px;
    font-weight: 600;
  }

  &__hint {
    margin: 0;
    color: $gray;
    font-size: 13px;

    &--mobile {
      display: none;
    }

    @include mobile-sm-max {
      &--desktop {
        display: none;
      }

      &--mobile {
        display: block;
      }
    }
  }

  &__groups {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;

    @include mobile-sm-max {
      display: none;
    }
  }
}
</style>
